module.exports = __webpack_public_path__ + "img/union4Img.63c308ca.png";